import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { apiBaseUrl } from 'src/config';
import { replaceDatesWithISOStrings } from './model';
import { catchError } from 'rxjs/operators';

export interface Operator {
  id: string;
  name: string;
  role: string;
  location: string;
}

export interface OperatorSkills {
  id: string;
  skillsByMachine: Record<string, number>;
}

const baseUrl = `${apiBaseUrl}/data/operators`;

@Injectable()
export class OperatorsApi {
  private readonly http = inject(HttpClient);

  getOperators$(): Observable<Operator[]> {
    return this.http.get<Operator[]>(baseUrl).pipe(catchError(() => of([])));
  }

  getOperatorSkills$(
    operatorIds: string[],
    machineIds: string[],
    range: { from: Date; to: Date }
  ): Observable<OperatorSkills[]> {
    return this.http
      .post<OperatorSkills[]>(baseUrl, {
        operatorIds,
        machineIds,
        ...replaceDatesWithISOStrings(range),
      })
      .pipe(catchError(() => of([])));
  }
}
